export type OperatorValue = {
    value: any;
};

export enum CheckStatusFilterBoolean {
    isNotChecked = 'isNotChecked',
    isChecked = 'isChecked'
}
